export const EMPLOYEE_DOCUMENT_KINDS = ['CONTRACT', 'ID', 'CERTIFICATION', 'MEDICAL', 'OTHER'] as const;
export type EmployeeDocumentKind = (typeof EMPLOYEE_DOCUMENT_KINDS)[number];

/** What HR is reminded about ahead of time: a document's expiry, the end of a probation, the end of a contract. */
export const EMPLOYEE_DUE_KINDS = ['DOCUMENT', 'PROBATION', 'CONTRACT'] as const;
export type EmployeeDueKind = (typeof EMPLOYEE_DUE_KINDS)[number];
